import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsFormsModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { FilterCriteria } from '../../model/reporting.model';

@Component({
  selector: 'cdf-reporting-options-filter',
  imports: [DsFormsModule, FormsModule],
  template: `<div class="reporting-options-filter-grid">
    <ds-form-field>
      <label ds-label for="country">{{ i18n('reporting.country') }}</label>
      <ds-select id="country" [showClearAll]="true" [options]="countryOptions()" [(ngModel)]="selectedCountry" />
    </ds-form-field>

    <ds-form-field>
      <label ds-label for="usecase">{{ i18n('reporting.usecase') }}</label>
      <ds-select
        id="usecase"
        isMultiselect
        [showClearAll]="true"
        [options]="usecaseOptions()"
        [(ngModel)]="selectedUsecases"
      />
    </ds-form-field>
  </div> `,
  styleUrl: './reporting-options-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingOptionsFilterComponent {
  protected readonly i18n = useI18n();

  protected readonly optionsChanged = output<Partial<FilterCriteria>>();

  readonly countries = input<string[]>([]);
  protected readonly countryOptions = computed(() => {
    return this.countries()
      .sort((a, b) => a.localeCompare(b))
      .map((c) => ({ id: c, label: c }));
  });

  readonly usecases = input<string[]>([]);
  protected readonly usecaseOptions = computed(() => {
    return this.usecases()
      .sort((a, b) => a.localeCompare(b))
      .map((u) => ({ id: u, label: u }));
  });

  protected readonly selectedCountry = signal<string | undefined>(undefined);
  protected readonly selectedUsecases = signal<string[]>([]);

  constructor() {
    effect(() => {
      this.optionsChanged.emit({
        country: this.selectedCountry(),
        usecases: this.selectedUsecases(),
      });
    });
  }
}
